import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlag1Line = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 3C4.89543 3 4 3.89543 4 5V21C4 21.5523 4.44772 22 5 22C5.55229 22 6 21.5523 6 21V16H19.8036C20.7026 16 21.222 14.9801 20.6932 14.253L17.2365 9.5L20.6932 4.74699C21.222 4.01992 20.7026 3 19.8036 3H6ZM6 14V5H18.0362L15.4051 8.61774C15.0226 9.14372 15.0226 9.85628 15.4051 10.3823L18.0362 14H6Z"
	})
});
export default SvgFlag1Line;
